<at-header
  [menuControls]="sidenavPanelId"
  [menuExpanded]="sidenavOpen()"
  [showMenuBtn]="showSidenav()"
  (menuBtnClick)="toggleSidenav()"
>
  <ng-container headerActions>
    @if (isLoggedIn()) {
      <app-user-overlay-select />
    } @else {
      @if (isSignIn()) {
        <a class="link" routerLink="/register">
          {{ dictionary.signUpLink }}
        </a>
      } @else {
        <a class="link" routerLink="/login">
          {{ dictionary.signInLink }}
        </a>
      }
    }
  </ng-container>
</at-header>

@if (showSidenav()) {
  <at-sidenav class="header-sidenav" [panelId]="sidenavPanelId" [(open)]="sidenavOpen">
    <div class="sidenav-header">
      <a class="sidenav-logo" routerLink="/dashboard" (click)="toggleSidenav()">
        <img
          alt="AnotherTrip logo"
          class="header-logo-img"
          height="32"
          ngSrc="assets/icons/logo-at-light.svg"
          width="137"
        />
      </a>
      <button
        aria-label="Close navigation menu"
        atButton
        title="Close navigation menu"
        type="button"
        variant="plain"
        (click)="toggleSidenav()"
      >
        <at-icon>close</at-icon>
      </button>
    </div>
    <div class="sidenav-content">
      <app-dashboard-nav (itemClick)="toggleSidenav()" />
    </div>
  </at-sidenav>
}

@if (showLoadingBar()) {
  <div class="loading-bar"></div>
}
